/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { Fragment, useEffect, useState } from 'react';
import { Row, Collapse, Card, Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, CustomInput } from 'reactstrap';
import {
    Separator,
    Colxx,
} from '../../../../components/common/CustomBootstrap';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import DocumentForm from './Components/DocumentForm';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_Documents, postAPI_Business_Operator_PublishGPT } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DocumentList from './Components/DocumentList';
import Logs from './Components/Logs';
import Validation from '../../../../components/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import no_document from './../../../../assets/no_document.png';
import folder_img from './../../../../assets/folder_img.png';
import { NotificationManager } from '../../../../components/common/react-notifications';
import IntlMessages from '../../../../helpers/IntlMessages';
import CreateFolderButton from '../propinfo/gallery/components/CreateFolderButton';
import EditFolderForm from '../propinfo/gallery/components/EditFolderForm';
import DeleteFolder from '../propinfo/gallery/components/DeleteFolder';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;

const sortOptions = [
    { 'text': 'Title A to Z', value: 'Title:ASC', label: 'Title ASC' },
    { 'text': 'Title Z to A', value: 'Title:DESC', label: 'Title DESC' },
    { 'text': 'Date Newest to Oldest', value: 'Date:DESC', label: 'Date DESC' },
    { 'text': 'Date Oldest to Newest', value: 'Date:ASC', label: 'Date ASC' },
]


const Documents = ({ match, propertyId, locale, email, userName }) => {
    const [loading, setLoading] = useState(true);
    const [sortType, setSortType] = useState('Title:ASC');
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [createDocument, setCreateDocument] = useState(false);
    const [showLogs, setShowLogs] = useState(false);
    const [tags, setTags] = useState([]);
    const [documentList, setDocumentList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkboxes, setCheckboxes] = useState({
        pii: false,
        confidentiality: false,
        harmfulfree: false,
    });
    const [isFormValid, setIsFormValid] = useState(false);
    const [folders, setFolders] = useState(0);
    const [allFolders, setAllFolders] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState('root');
    const [subfolders, setSubfolders] = useState([]);
    const [folderName, setFolderName] = useState('');
    const [folderId, setFolderId] = useState(null);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [status, setStatus] = useState('Active');
    const toggleCreateModal = () => setIsCreateModalOpen(!isCreateModalOpen);
    const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);
    const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);
    const handleToggle = () => {
        setCreateDocument(!createDocument);
    }


    useEffect(() => {
        LoadData();
    }, [propertyId, sortType, selectedFolder]);

    const LoadData = () => {
        AxiosAPI({
            method: 'get',
            url: `${API_Documents}?groupId=${getGroupID()}&propertyId=${propertyId}&sortType=${sortType}&path=${selectedFolder}`,
        }).then((res) => {
            if (res.data.documentList != null && res.data.documentList.length > 0) {
                res.data.documentList.map((m) => {
                    if (m.tags !== undefined && m.tags.length > 0) {
                        m.tags.map((t) => {
                            if (tags.filter(m => m == t).length === 0)
                                tags.push(t);
                        })
                    }
                })
            }
            setDocumentList(res.data.documentList);
            setAllFolders(res.data.allFolders);
            setFolders(res.data.folders);
            setTimeout(() => {

                setLoading(false);
            }, 500);
        });
    };

    // update folder
    const handleEditFolder = (folder) => {
        setFolderName(folder.folderName);
        setFolderId(folder.id);
        toggleEditModal();
    };
    const updateFolderName = (updatedFolder) => {
        setFolders((prevFolders) =>
            prevFolders.map((folder) =>
                folder.id === updatedFolder.id
                    ? { ...folder, folderName: updatedFolder.name }
                    : folder
            )
        );
    };
    const handleDeleteFolder = (folder) => {
        setFolderName(folder.folderName);
        setFolderId(folder.id);
        toggleDeleteModal();
    };
    const deleteFolderById = (folderId) => {
        setFolders((prevFolders) =>
            prevFolders.filter((folder) => folder.id !== folderId)
        );
    };

    const handleAddDocument = (inputData) => {
        const payload = {
            ...inputData,
            path: selectedFolder,
        };
        AxiosAPI({
            method: 'post',
            url: API_Documents,
            data: payload,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                handleToggle();
                LoadData();
            }
        });
    };
    //on folder click
    const handleFolderClick = (folderName) => {
        setLoading(true);
        const currentPath = selectedFolder.split('/');

        if (!currentPath.includes(folderName)) {
            setSelectedFolder((prev) => `${prev}/${folderName}`);
            setSubfolders((prev) => [...prev, folderName]);
        }
    };
    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setCheckboxes((prev) => {
            const updatedCheckboxes = { ...prev, [name]: checked };
            setIsFormValid(updatedCheckboxes.pii && updatedCheckboxes.confidentiality && updatedCheckboxes.harmfulfree);
            return updatedCheckboxes;
        });
    };
    const handlePublish = () => {
        var body = {
            GroupId: getGroupID(),
            PropertyId: propertyId,
            Language: locale === 'en' ? 'en-US' : locale,
            email: email,
            version: 3,
            type: 1,
            Creator: 'dashboard',
        };
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Business_Operator_PublishGPT}`,
            data: body,
        }).then(() =>
            NotificationManager.success(
                '',
                'We have received your request. Publish will take few minutes.',
                3000,
                null,
                null,
                'success'
            )
        );
        toggleModal();
    };

    const handleShowLogs = () => {
        setShowLogs(!showLogs);
    }

    const handleBackClick = () => {
        setLoading(true);
        const currentPath = selectedFolder.split('/');

        if (currentPath.length > 1) {
            const newPath = currentPath.slice(0, currentPath.length - 1).join('/');
            setSelectedFolder(newPath);
        } else {
            setSelectedFolder('root');
        }
    };
    const getFolderPath = () => {
        const pathComponents = selectedFolder
            .split('/')
            .filter((folder) => folder && folder !== 'root');
        return pathComponents.join(' > ');
    };
    console.log(208, folders);
    const getSortedList = (list, sortType) => {
        if (!list) return [];
        const sorted = [...list];
        switch (sortType) {
            case 'Title:ASC':
                return sorted.sort((a, b) => (a.title ?? '').localeCompare(b.title ?? ''));
            case 'Title:DESC':
                return sorted.sort((a, b) => (b.title ?? '').localeCompare(a.title ?? ''));
            case 'Date:DESC':
                return sorted.sort((a, b) => new Date(b.date) - new Date(a.date));
            case 'Date:ASC':
                return sorted.sort((a, b) => new Date(a.date) - new Date(b.date));
            default:
                return sorted;
        }
    };
    return (
        <Fragment>
            <div className="mb-3">
                <h4><b><IntlMessages id="dashboards.trainAI" /></b></h4>
                <p>  <IntlMessages id="dashboards.uploadDocuments" /></p>
            </div>

            <Row>
                <Colxx xxs="12" className="mb-0">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        <DropdownToggle caret color="outline-dark" size="xs">
                            <IntlMessages id='dashboards.order-by' />
                            {sortOptions.filter(f => f.value === sortType).length > 0 ? ": " + sortOptions.filter(f => f.value === sortType)[0].label : ""}
                        </DropdownToggle>
                        <DropdownMenu>
                            {sortOptions.map((order, index) => {
                                return (
                                    <DropdownItem
                                        key={index}
                                        onClick={() => setSortType(order.value)}
                                    >
                                        {order.text}
                                    </DropdownItem>
                                );
                            })}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    <Button size="xs" outline className='' onClick={handleToggle} color='primary'> + <IntlMessages id='dashboards.adddocument' /></Button >
                    <Button size="xs" outline className='ml-2' color='primary' onClick={handleShowLogs}><IntlMessages id='dashboards.changelog' /></Button >
                    {propertyId !== '-1' && (
                        <CreateFolderButton
                            userName={userName}
                            propertyId={propertyId}
                            parentLoadData={LoadData}
                            selectedFolder={selectedFolder}
                            visible={isCreateModalOpen}
                            toggleModal={toggleCreateModal}
                            folderName={folderName}
                            setFolderName={setFolderName}
                            status={status}
                            type={"Document"}
                        ></CreateFolderButton>
                    )}{/* <Button size="xs" outline className='ml-2' color='primary' onClick={toggleModal}>Publish GPT</Button > */}
                    {locale && locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                        <Button
                            color="primary"
                            outline
                            className='ml-2'
                            size="xs"
                        >
                            Publish AI
                        </Button>
                    </a>
                    }
                </Colxx>
            </Row>
            <Separator className="mt-1" />
            {selectedFolder !== 'root' && (
                <Colxx xxs="12" className="mb-0">
                    <div className="mb-2">
                        <div className="d-flex mt-2">
                            <Button
                                color="primary"
                                outline
                                className=" mt-1"
                                size="xs"
                                onClick={handleBackClick}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </Button>
                            <h6 className="ml-2 mt-2">
                                <b>{getFolderPath()} </b>{' '}
                            </h6>
                        </div>
                    </div>
                </Colxx>
            )}
            {!loading ?
                <Fragment>
                    <Card className="my-3">
                        {(documentList !== undefined && documentList !== null && documentList.length) > 0 ||
                            (folders !== undefined && folders != null && folders.length > 0) ? (
                            <Colxx xxs="12" className="">
                                <Colxx xxs="12" className="mb-2">
                                    {folders && folders.length > 0 && (
                                        <div className="folder-wrap relative mt-4">
                                            {folders.map((folder, index) => (
                                                <Fragment>
                                                    <div key={index} className="folder-content">
                                                        <img
                                                            src={folder_img}
                                                            style={{ width: '6rem' }}
                                                            alt="No Gallery"
                                                            onClick={() =>
                                                                handleFolderClick(folder.folderName)
                                                            }
                                                        />
                                                        <h6 className="text-center">
                                                            {' '}
                                                            {folder.folderName}
                                                        </h6>
                                                        <a
                                                            href="#/"
                                                            className="editbutton"
                                                            style={{
                                                                background: 'transparent',
                                                                borderRadius: '0%',
                                                                transition: '0.2s',
                                                            }}
                                                            onMouseEnter={(e) =>
                                                                (e.currentTarget.style.backgroundColor = 'rgba(0, 50, 255, 0.2)')
                                                            }
                                                            onMouseLeave={(e) =>
                                                                (e.currentTarget.style.backgroundColor = 'transparent')
                                                            }
                                                            onClick={() => handleEditFolder(folder)}
                                                        >
                                                            {' '}
                                                            <i className="glyph-icon simple-icon-pencil" />{' '}
                                                        </a>
                                                        <a
                                                            href="#/"
                                                            className="delete"
                                                            style={{
                                                                background: 'transparent',
                                                                borderRadius: '0%',
                                                                transition: '0.2s',
                                                            }}
                                                            onMouseEnter={(e) =>
                                                                (e.currentTarget.style.backgroundColor = 'rgba(255, 0, 0, 0.2)')
                                                            }
                                                            onMouseLeave={(e) =>
                                                                (e.currentTarget.style.backgroundColor = 'transparent')
                                                            }
                                                            onClick={() => handleDeleteFolder(folder)}
                                                        >
                                                            {' '}
                                                            <i className="glyph-icon simple-icon-trash" />{' '}
                                                        </a>
                                                    </div>
                                                </Fragment>
                                            ))}
                                        </div>
                                    )}
                                    {isEditModalOpen ? (
                                        <EditFolderForm
                                            visible={isEditModalOpen}
                                            toggleModal={toggleEditModal}
                                            userName={userName}
                                            formLabel="Edit Folder"
                                            folderName={folderName}
                                            setFolderName={setFolderName}
                                            folderId={folderId}
                                            status={status}
                                            selectedFolder={selectedFolder}
                                            updateFolderName={updateFolderName}
                                        />
                                    ) : (
                                        ''
                                    )}
                                    {isDeleteModalOpen ? (
                                        <DeleteFolder
                                            visible={isDeleteModalOpen}
                                            toggleModal={toggleDeleteModal}
                                            folderName={folderName}
                                            folderId={folderId}
                                            status={status}
                                            selectedFolder={selectedFolder}
                                            deleteFolderById={deleteFolderById}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </Colxx>
                                <Colxx xxs="12" className="mb-4">
                                    <DocumentList tags={tags} LoadData={LoadData} documentList={documentList} folders={allFolders} selectedFolder={selectedFolder} sortType={sortType} />
                                </Colxx>
                            </Colxx>)
                            : <Colxx xxs="12" className="mb-4 text-center"><img className='w-25' style={{ marginTop: '5rem' }} src={no_document}></img></Colxx>
                        }
                    </Card>
                </Fragment> :
                <div className="loading" />
            }
            {createDocument &&
                <DocumentForm taglist={tags} label={"Upload Document"} LoadData={LoadData} toggle={handleToggle} submit={handleAddDocument} visible={createDocument} selectedFolder={selectedFolder} ></DocumentForm>
            }

            {showLogs &&
                <Logs label={"Document Logs"} toggle={handleShowLogs} visible={showLogs} logType="Document" ></Logs>
            }

            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>

        </Fragment >
    );
};

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, userName, email } = settings;
    return {
        propertyId,
        locale,
        email,
        userName
    };
};

export default injectIntl(connect(mapStateToProps, {})(Documents));
